import { connect } from 'react-redux';
import React, { Component, Fragment } from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { CREATE_EDIT_TRANSFER_FORM_NAME } from 'Common/FormEnum';
import { FilterEnum, CreateEditTransferEnum } from 'Common/FieldEnum';
import { resetForm } from 'State/forms/actions';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import {
  DATE_FORMAT_FOR_UI,
  UNSAVED_MESSAGE,
  DATE_FORMAT_FOR_SERVER,
} from 'Common/Constants';
import { NotificationDialog } from 'Components';
import { NewEditTransferEnum } from 'Common/Constants/Enumeration/ManageTransferEnum';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { resetDirty } from 'State/dirtyTracking/actions';
import * as FilterSelectors from 'State/filters/selectors';

import { actions } from '../../state/actions';
import CreateEditTransferComponent from '../../components/createEditTransfer/CreateEditTransfer';
import * as CreateEditTransferSelectors from '../../state/createEditTransfer/selectors';

class CreateEditTransferContainer extends Component {
  static propTypes = {
    resetForm: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,

    transferDT: PropTypes.string,
    fromSite: PropTypes.string,
    fromSiteName: PropTypes.string,
    toSiteName: PropTypes.string,
    editedTransferData: PropTypes.array,
  };
  static defaultProps = {
    fromSite: '0',
    toSite: '0',
    transferDT: moment().format(DATE_FORMAT_FOR_UI),
    fromSiteName: '',
    toSiteName: '',
    editedTransferData: [],
  };
  state = {
    showUnsavedFiltersModal: false,
    activeIndexForFilter: 0,
    fromSite: '',
    toSite: '',
    filterValues: {
      [FilterEnum.GroupId_Bid]: 0,
      [FilterEnum.GroupId_Item]: 0,
    },
    SiteAndDeliveryDate: {
      newValue: null,
      previousValue: null,
      site: '',
    },
  };

  componentDidUpdate = () => {
    const { IsNewEdit } = this.props;
    if (IsNewEdit === NewEditTransferEnum.EDIT) {
      this.props.resetDirty();
    }
  };

  componentDidMount = () => {
    this.props.getToSites();
  };

  handleChange = (e, values) => {
    this.setState({ filterValues: values }, () => this.getFilterData());
  };

  handleUnsavedFilterDialog(result) {
    if (result) {
      this.setState({ showUnsavedFiltersModal: false });
      this.getFilterData();
    } else {
      const { previousValue, site } = this.state.SiteAndDeliveryDate;
      site === CreateEditTransferEnum.FromSite
        ? this.props.change([CreateEditTransferEnum.FromSite], previousValue)
        : this.props.change([CreateEditTransferEnum.TransferDT], previousValue);
      this.setState({
        showUnsavedFiltersModal: false,
        fromSite:
          site === CreateEditTransferEnum.FromSite
            ? previousValue
            : this.state.fromSite,
      });
    }
  }

  clearFilters = () => {
    const { IsNewEdit, TransferId } = this.props;

    let filterValues = {
      [FilterEnum.GroupId_Bid]: 0,
      [FilterEnum.GroupId_Item]: 0,
    };
    this.setState({
      filterValues: filterValues,
      showUnsavedFiltersModal: false,
      fromSite: '',
    });
    this.props.resetForm(CREATE_EDIT_TRANSFER_FORM_NAME);
    if (IsNewEdit !== NewEditTransferEnum.NEW) {
      this.props.getTransferDetail(TransferId);
    } else {
      this.props.emptyItemList();
    }
  };

  onChangeOfToSite = toSite => {
    this.setState({
      toSite: toSite,
    });
  };
  onChangeOfSite = site => {
    if (site === this.props.fromSite) {
      return;
    }
    if (this.props.editedTransferData.length) {
      this.setState({
        showUnsavedFiltersModal: true,
        fromSite: site,
        SiteAndDeliveryDate: {
          newValue: site,
          site: CreateEditTransferEnum.FromSite,
        },
      });
    } else {
      this.setState({
        fromSite: site,
      });
      this.getFilterData({
        newValue: site,
        site: CreateEditTransferEnum.FromSite,
      });
    }
  };

  onChangeOfDate = (event, newValue, previousValue, site) => {
    if (newValue === previousValue) {
      return;
    }
    let siteValue = this.props.fromSite;
    if (site === CreateEditTransferEnum.FromSite) {
      siteValue = newValue;
    }
    if (
      newValue !== previousValue &&
      previousValue !== NewEditTransferEnum.NEW &&
      this.props.editedTransferData.length
    ) {
      this.setState({
        showUnsavedFiltersModal: true,
        fromSite: siteValue,
        SiteAndDeliveryDate: {
          newValue,
          previousValue,
          site,
        },
      });
    } else {
      this.setState({
        fromSite: siteValue,
      });
      this.getFilterData({
        newValue,
        previousValue,
        site,
      });
    }
  };

  getFilterData = obj => {
    const { newValue, site } = obj ? obj : this.state.SiteAndDeliveryDate;
    const {
      IsNewEdit,
      transferDT,
      fromSite,
      TransferId,
      setResetPageOnDataChangeValue,
    } = this.props;
    let tempSiteId = fromSite;
    let delvDate = transferDT;
    if (site === CreateEditTransferEnum.FromSite) {
      tempSiteId = newValue;
    } else {
      delvDate = newValue;
    }
    const filtersOptions = {
      Groupid_Bid: this.state.filterValues.GroupId_Bid,
      Groupid_Item: this.state.filterValues.GroupId_Item,
      Site: tempSiteId,
      TransferDT: moment(delvDate).format(DATE_FORMAT_FOR_SERVER),
    };
    if (
      tempSiteId &&
      tempSiteId.length &&
      tempSiteId !== GenericEnum.ZeroString &&
      delvDate
    ) {
      this.props.getTransferItems(filtersOptions).then(() => {
        if (IsNewEdit !== NewEditTransferEnum.NEW) {
          this.props.getTransferDetail(TransferId);
        }
        if (
          this.props.editedTransferData &&
          this.props.editedTransferData.length
        ) {
          let transferList = [];
          this.props.transferItemsData.forEach(item => {
            _.some(this.props.editedTransferData, obj => {
              if (
                item[CreateEditTransferEnum.ItemCode] ===
                obj[CreateEditTransferEnum.ItemCode]
              ) {
                transferList.push(obj);
                return true;
              }
            });
          });
          this.props.setModifiedTransferItems(transferList);
          this.props.reorderItemList(transferList);
        }
      });
    }
    setResetPageOnDataChangeValue(true);
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexForFilter } = this.state;
    const newIndex = activeIndexForFilter === index ? -1 : index;
    this.setState({
      activeIndexForFilter: newIndex,
    });
  };

  render() {
    const {
      transferItemsData,
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      IsNewEdit,
      fetchingTransferItems,
      showNotificationModal,
      hideNotificationModal,
      message,
      resetPageOnDataChange,
      onResetPageOnDataChange,
      fromSite,
      fromSiteName,
      toSiteName,
      toSites,
    } = this.props;

    const { filterValues, showUnsavedFiltersModal } = this.state;
    const filterValuesData = {};
    _.map(filterValues, function(value, key, items) {
      if (+items[key]) {
        filterValuesData[key] = items[key];
      }
    });

    const newData = Object.keys(filterValuesData).length
      ? _.filter(transferItemsData, filterValuesData)
      : transferItemsData;
    return (
      <Fragment>
        <CreateEditTransferComponent
          isDisabled={this.props.isDisabled}
          IsNewEdit={IsNewEdit}
          assignItemsBidGroupData={assignItemsBidGroupData}
          assignItemsItemGroupData={assignItemsItemGroupData}
          clearFilters={this.clearFilters}
          handleChange={this.handleChange}
          filterValues={filterValues}
          onChangeOfFromSite={this.onChangeOfSite}
          onChangeOfToSite={this.onChangeOfToSite}
          onChangeOfDate={this.onChangeOfDate}
          transferItemsData={newData}
          fetchingTransferItems={fetchingTransferItems}
          resetPageOnDataChange={resetPageOnDataChange}
          onResetPageOnDataChange={onResetPageOnDataChange}
          activeIndexForFilter={this.state.activeIndexForFilter}
          handleClick={this.handleClick}
          fromSite={fromSite}
          fromSiteName={fromSiteName}
          toSiteName={toSiteName}
          toSites={toSites}
        />
        <YesNoDialog
          showDialog={showUnsavedFiltersModal}
          title="Un-saved changes detected"
          question={UNSAVED_MESSAGE}
          yesCallback={() => {
            this.handleUnsavedFilterDialog(true);
          }}
          noCallback={() => {
            this.handleUnsavedFilterDialog(false);
          }}
        />
        <NotificationDialog
          title={'Transfer Orders'}
          showDialog={showNotificationModal}
          message={message}
          onOkClick={hideNotificationModal}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(CREATE_EDIT_TRANSFER_FORM_NAME);
const mapStateToProps = state => {
  return {
    transferDT: selector(state, [CreateEditTransferEnum.TransferDT]),
    fromSite: selector(state, [CreateEditTransferEnum.FromSite]),
    fromSiteName: selector(state, [CreateEditTransferEnum.FromSiteName]),
    toSiteName: selector(state, [CreateEditTransferEnum.ToSiteName]),
    editedTransferData: selector(state, [
      CreateEditTransferEnum.TransferItemsInfo,
    ]),
    assignItemsBidGroupData: FilterSelectors.selectBidGroupData(state),
    assignItemsItemGroupData: FilterSelectors.selectItemGroupData(state),
    transferItemsData: CreateEditTransferSelectors.getTransferItems(state),
    toSites: CreateEditTransferSelectors.getToSites(state),
  };
};

CreateEditTransferContainer = reduxForm({
  form: CREATE_EDIT_TRANSFER_FORM_NAME,
  destroyOnUnmount: false,
})(CreateEditTransferContainer);

const mapDispatchToProps = {
  resetForm,
  resetDirty,
  ...actions,
};
export const CreateEditTransfer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEditTransferContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/containers/createEditTransfer/CreateEditTransfer.js